import { render, staticRenderFns } from "./CommunicationTypeCards.vue?vue&type=template&id=1de1aa3f&"
import script from "./CommunicationTypeCards.vue?vue&type=script&lang=js&"
export * from "./CommunicationTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports